module.exports = __webpack_public_path__ + "static/img/rwaq.59f2d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rwaq.png
// module id = YJPC
// module chunks = 0